var React = require('react');

function CircleCheckbox (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"22","height":"22","rx":"11","fill":"#1A1718","key":0}),React.createElement("path",{"d":"M6.17543 11.2347L9.63483 14.6941L16.2875 8.04143","stroke":"white","strokeWidth":"1.50533","key":1})]);
}

CircleCheckbox.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = CircleCheckbox;

CircleCheckbox.default = CircleCheckbox;
